import { currentLanguage } from '../constants/common';
import { findCookieValue } from './utility';

export class CommonHeaders {
	public static get LOGIN_HEADERS() {
		return {
			'Request-Language': currentLanguage,
			'x-odds-session': findCookieValue('x-odds-session'),
		};
	}
}
